// removed by extract-text-webpack-plugin
module.exports = {"cardList":"_2w6huit","card":"KTAuE-M","thumbnailWrapper":"NPj3xtK","thumbnailCover":"_22rWNyi","light":"N6VouQo","dark":"_3NrgMYK","image":"_2FeYvLi","cardTitle":"_2dXAV_L","cardDescription":"H-xkL3W"};


//////////////////
// WEBPACK FOOTER
// ./template/components/Navigation/LargeSecondaryNavigation/ImageCardsWithDescription/Wrapper.css
// module id = ./template/components/Navigation/LargeSecondaryNavigation/ImageCardsWithDescription/Wrapper.css
// module chunks = client.sitechrome